export const docksMapTranslations = {
  en: {
    pageTitle: 'Nautical chart',
    legend: 'Legend',
    waterway: 'Navigable waterway',
    docks: 'Docks',
    hydrometers: 'Hydrometers',
    bathymetricMonitoring: 'Bathymetric monitoring - values in cm',
    signage: 'Signage',
    navigationWarnings: 'Navigation warnings',
    dangerZoneLegend: 'Danger zones (red tint and red border)',
    satellite: 'Satellite',
    street: 'Street',
    loading: 'Loading Docks...',
    noDocksMemory: 'No dock information in memory - restart the app and try again',
    noWarningsMemory: 'No navigation warning information in memory - restart the app and try again',
    noSignsMemory: 'No signage information in memory - restart the app and try again',
    noBathymetricMemory: 'No bathymetric monitoring point information in memory - restart the app and try again',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving data from the server! Please restart the app and try again.',
    okButton: 'Ok',
    currentDistance: 'Current distance:',
    calculating: 'Calculating...',
    location: 'Location:',
    latitude: 'Latitude:',
    longitude: 'Longitude:',
    elevation: 'Elevation:',
    elevationUnit: 'm',
    elevationBelow: 'Elevation below:',
    elevationAbove: 'Elevation above:',
    riverSection: 'River section:',
    riverZone: 'River zone:',
    id: 'Id:',
    description: 'Description:',
    shore: 'Shore:',
    recenterOnUser: 'Center on my location'
  },
  it: {
    pageTitle: 'Carta nautica',
    legend: 'Legenda',
    waterway: 'Idrovia navigabile',
    docks: 'Attracchi',
    hydrometers: 'Idrometri',
    bathymetricMonitoring: 'Monitoraggio batimetrico - valori in cm',
    signage: 'Segnaletica',
    navigationWarnings: 'Avvisi alla navigazione',
    dangerZoneLegend: 'Zone di pericolo (area rossa semitrasparente e bordo rosso)',
    satellite: 'Satellitare',
    street: 'Stradale',
    loading: 'Caricamento Attracchi...',
    noDocksMemory: 'Non sono presenti informazioni sugli attracchi in memoria - riavviare l\'app e riprovare',
    noWarningsMemory: 'Non sono presenti informazioni sugli avvisi di cauta navigazione in memoria - riavviare l\'app e riprovare',
    noSignsMemory: 'Non sono presenti informazioni sulla segnaletica in memoria - riavviare l\'app e riprovare',
    noBathymetricMemory: 'Non sono presenti informazioni sui punti di rilievo batimetrico in memoria - riavviare l\'app e riprovare',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati dal server! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok',
    currentDistance: 'Attuale distanza:',
    calculating: 'Calcolo...',
    location: 'Località:',
    latitude: 'Latitudine:',
    longitude: 'Longitudine:',
    elevation: 'Elevazione:',
    elevationUnit: 'm',
    elevationBelow: 'Elevazione sotto:',
    elevationAbove: 'Elevazione sopra:',
    riverSection: 'Tratto:',
    riverZone: 'Presidio:',
    id: 'Id:',
    description: 'Descrizione:',
    shore: 'Sponda:',
    recenterOnUser: 'Centra sulla mia posizione'
  }
}; 